import * as functions from "./functions"

const themeConfig = {
  app: {
    appName: "",
    // appLogoImage: require('@src/assets/logo.png').default
    appLogoImage:
      "https://cdn11.bigcommerce.com/s-5h8rqg02f8/images/stencil/250x100/subtract_1617795361__77099.original.png"
  },
  layout: {
    isRTL: false,
    skin: "light", // light, dark, bordered, semi-dark
    routerTransition: "fadeIn", // fadeIn, fadeInLeft, zoomIn, none or check this for more transition https://animate.style/
    type: "vertical", // vertical, horizontal
    contentWidth: "full", // full, boxed
    menu: {
      isHidden: false,
      isCollapsed: false
    },
    navbar: {
      // ? For horizontal menu, navbar type will work for navMenu type
      type: "floating", // static , sticky , floating, hidden
      backgroundColor: "white" // BS color options [primary, success, etc]
    },
    footer: {
      type: "static" // static, sticky, hidden
    },
    customizer: false,
    scrollTop: true // Enable scroll to top button,
  },
  kapivaAppUrl: process.env.REACT_APP_KAPIVA_APP_URL,
  backendUrl: process.env.REACT_APP_BACKEND_URL,
  bigcommerceCoupon: process.env.REACT_APP_BIGCOMMERCE_COUPON,
  maxBulkOrders: 1000,
  storeUrl: process.env.REACT_APP_STORE_URL,
  comorbidityBackendUrl: process.env.REACT_APP_COMORBIDITY_BACKEND_URL,
  kapivaCashLedgerURL: process.env.REACT_APP_KAPIVA_CASH_LEDGER_URL,
  kapivaAppDashboardBackendURl: process.env.REACT_APP_KAPIVA_APP_DASHBOARD_BACKEND_URL,
  bulkBookingBackendUrl: process.env.REACT_APP_BULK_BOOKING_BACKEND_URL,
  skinPdpBackendUrl: process.env.REACT_APP_SKIN_PDP_BACKEND_URL,
  mediaUploaderBackendUrl: process.env.REACT_APP_MEDIA_UPLOADER_BACKEND_URL,
  bestPriceBackendUrl: process.env.REACT_APP_BEST_PRICE_BACKEND_URL,
  functions
}

export default themeConfig
